import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { IProductAvailabilityReq, ICartItem, ICartUpdate, ICatalog, IProductAvailability } from '../models/catalogs.models';
import { ILocation } from '../../auth/models/auth-response';
import { IInventoryFilter, IInventoryFilterRequest, IProduct, IVariant } from 'src/app/shared/models/products.models';
import { PageParams } from 'src/app/shared/models/request';

// fetch all catalogs
export const FetchAllCatalogs = createAction('[ Catalogs ] - FetchAllCatalogs');
export const FetchAllCatalogsSuccess = createAction(
  '[ Catalogs ] - FetchAllCatalogs Success ',
  props<{ catalogs: APIResponse<ICatalog> }>()
);
export const FetchAllCatalogsError = createAction('[ Catalogs ] - FetchAllCatalogs Error');

// Load Catalogs
export const LoadCatalogs = createAction(
  '[ Catalogs ] - LoadCatalogs',
  props<{ page: PageParams; key?: string; filter?: string }>()
);
export const LoadCatalogsSuccess = createAction(
  '[ Catalogs ] - LoadCatalogs Success ',
  props<{ resp: APIResponse<ICatalog> }>()
);
export const LoadCatalogsError = createAction(
  '[ Catalogs ] - LoadCatalogs Error',
  props<{ error: string }>()
);

// Append Catalogs
export const AppendCatalogs = createAction(
  '[ Catalogs ] - AppendCatalogs',
  props<{ page: PageParams; key?: string }>()
);
export const AppendCatalogsSuccess = createAction(
  '[ Catalogs ] - AppendCatalogs Success ',
  props<{ resp: APIResponse<ICatalog> }>()
);
export const AppendCatalogsError = createAction(
  '[ Catalogs ] - AppendCatalogs Error',
  props<{ error: string }>()
);

// get products
export const SetSelectedCatalog = createAction(
  '[ Catalogs ] - SetSelectedCatalog',
  props<{ catalog: Partial<ICatalog> }>()
);

// get products
export const FetchCatalogById = createAction(
  '[ Catalogs ] - FetchCatalogById',
  props<{ id: number }>()
);
export const FetchCatalogByIdSuccess = createAction(
  '[ Catalogs ] - FetchCatalogById Success ',
  props<{ catalog: ICatalog }>()
);
export const FetchCatalogByIdError = createAction('[ Catalogs ] - FetchCatalogById Error');

// Load Products
export const LoadProducts = createAction(
  '[ Catalogs ] - LoadProducts',
  props<{ id: number; page: PageParams; key?: string; filter?: IInventoryFilterRequest; sort_by?: string; sort_mode?: string  }>()
);
export const LoadProductsSuccess = createAction(
  '[ Catalogs ] - LoadProducts Success ',
  props<{ resp: APIResponse<ICatalog> }>()
);
export const LoadProductsError = createAction(
  '[ Catalogs ] - LoadProducts Error',
  props<{ error: string }>()
);

// Append Products
export const AppendProducts = createAction(
  '[ Catalogs ] - AppendProducts',
  props<{ id: number; page: PageParams; key?: string, filter?: IInventoryFilterRequest; sort_by?: string; sort_mode?: string }>()
);
export const AppendProductsSuccess = createAction(
  '[ Catalogs ] - AppendProducts Success ',
  props<{ resp: APIResponse<ICatalog> }>()
);
export const AppendProductsError = createAction(
  '[ Catalogs ] - AppendProducts Error',
  props<{ error: string }>()
);

// get locations by company id
export const GetLocationsByCompanyId = createAction(
  '[ Catalogs ] - GetLocationsByCompanyId',
  props<{ id: number }>()
);
export const GetLocationsByCompanyIdSuccess = createAction(
  '[ Catalogs ] - GetLocationsByCompanyId Success',
  props<{ locations: APIResponse<ILocation> }>()
);
export const GetLocationsByCompanyIdError = createAction(
  '[ Catalogs ] - GetLocationsByCompanyId Error'
);

// Cart actions
export const LoadCart = createAction('[ Catalogs ] - LoadCart');
export const LoadCartSuccess = createAction(
  '[ Catalogs ] - LoadCart Success',
  props<{ carts: ICartItem[] }>()
);
export const LoadCartFailure = createAction('[ Catalogs ] - LoadCart Failure');

export const AddToCart = createAction(
  '[ Catalogs ] - AddToCart',
  props<{ catalog: Partial<ICatalog>; product: IProduct | IVariant }>()
);
export const AddToCartSuccess = createAction(
  '[ Catalogs ] - AddToCart Success',
  props<{ cart: ICartItem }>()
);
export const AddToCartFailure = createAction('[ Catalogs ] - AddToCart Failure');

// Batch cart updates
export const BatchCartUpdate = createAction(
  '[ Catalogs ] - BatchCartUpdate',
  props<{ catalog: Partial<ICatalog>; products: (IProduct | IVariant)[] }>()
);
export const BatchCartUpdateSuccess = createAction(
  '[ Catalogs ] - BatchCartUpdate Success',
  props<{ cart: ICartItem }>()
);
export const BatchCartUpdateFailure = createAction('[ Catalogs ] - BatchCartUpdate Failure');

export const UpdateCart = createAction('[ Catalogs ] - UpdateCart', props<{ cart: ICartUpdate }>());
export const UpdateCartSuccess = createAction(
  '[ Catalogs ] - UpdateCart Success',
  props<{ cart: ICartItem }>()
);
export const UpdateCartFailure = createAction('[ Catalogs ] - UpdateCart Failure');

export const DeleteCart = createAction('[ Catalogs ] - DeleteCart', props<{ cartId: number }>());
export const DeleteCartSuccess = createAction(
  '[ Catalogs ] - DeleteCart Success',
  props<{ cart: ICartItem }>()
);
export const DeleteCartFailure = createAction('[ Catalogs ] - DeleteCart Failure');

export const  CheckProductsAvailability = createAction(
  '[ Catalogs ] - CheckProductsAvailability',
  props<{ data: IProductAvailabilityReq }>()
);

export const  CheckProducstAvailabilitySuccess = createAction(
  '[ Catalogs ] - CheckProductsAvailability Success',
  props<{ data: IProductAvailability }>()
);

export const  CheckProductsAvailabilityFailure = createAction(
  '[ Catalogs ] - CheckProductsAvailability Failure'
);

// Clear actions
export const EmptyCatalogs = createAction('[ Catalogs ] - EmptyCatalogs');
export const EmptyCatalog = createAction('[ Catalogs ] - EmptyCatalog');

export const Loading = createAction('[ Catalogs ] - Loading', props<{ loading: boolean }>());


// Filter actions
export const SetInventoryFilter = createAction(
  '[ Filters ] - SetInventoryFilter',
  // props<{ keyword: string, advanced: IInventoryFilter | null }>()
    props<{ advanced: IInventoryFilter | null }>()

);

// Search
export const SetOrderSearch = createAction(
  '[ Search ] - SetOrderSearch',
  props<{ keyword: string }>()
);
